module.exports = __webpack_public_path__ + "static/front-ef22d26c62cbd5bc458f8652f3699250.jpg";